module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.isCollapsed = !_vm.isCollapsed;
      }
    }
  }, [_c('div', {
    staticClass: "amount"
  }, [_c('div', {
    staticClass: "circle",
    style: ({
      backgroundColor: _vm.actionColor
    })
  }, [_vm._v(_vm._s(_vm.amount))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', [_c('div', {
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.isCollapsed = !_vm.isCollapsed;
      }
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (!_vm.isCollapsed) ? _c('div', {
    staticClass: "details"
  }, [_vm._l((_vm.forecasts), function(forecast) {
    return _c('div', {
      key: forecast.id,
      style: ({
        borderColor: _vm.actionColor
      })
    }, [_c('a', {
      attrs: {
        "href": ((_vm.ROUTES.BASE) + "/" + (forecast.id))
      }
    }, [_vm._v(_vm._s(forecast.reference) + " • " + _vm._s(forecast.name))])])
  }), _vm._v(" "), _vm._l((_vm.forecastWindows), function(forecastWindow) {
    return _c('div', {
      key: forecastWindow.id,
      style: ({
        borderColor: _vm.actionColor
      })
    }, [_c('a', {
      attrs: {
        "href": ((_vm.ROUTES.BASE) + "/window/" + (forecastWindow.id))
      }
    }, [_vm._v(_vm._s(forecastWindow.forecastReference) + " • " + _vm._s(forecastWindow.forecastName) + " • " + _vm._s(forecastWindow.zoneName))])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "arrow",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.isCollapsed = !_vm.isCollapsed;
      }
    }
  }, [(_vm.isCollapsed) ? [_vm._v("\n            ◂\n        ")] : [_vm._v("\n            ▾\n        ")]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7268d9fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/widgets/RequiredActionsItem.vue
// module id = 3267
// module chunks = 0